import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [{ title: "menu_sidebar_management_user" }, { title: "menu_sidebar_lead_view", link: "/leads" }];

const HealthLeadsListing = Loadable({
  loader: () => import("container/management/leads/healthLeads/healthLeadsListing"),
  loading() {
    return <Loader />;
  }
});
const HealthLeadsForm = Loadable({
  loader: () => import("container/management/leads/healthLeads"),
  loading() {
    return <Loader />;
  }
});
const AutoLeadsListing = Loadable({
  loader: () => import("container/management/leads/autoLeads/autoLeadsListing"),
  loading() {
    return <Loader />;
  }
});
const AutoLeadsForm = Loadable({
  loader: () => import("container/management/leads/autoLeads"),
  loading() {
    return <Loader />;
  }
});

export const leadRoutes: IRoute[] = [
  {
    path: "management/leads/auto",
    element: <AutoLeadsListing />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  },
  {
    path: "management/leads/auto/leads-form/:id?",
    element: <AutoLeadsForm />,
    handle: {
      crumbs: [...parentBreadCrumbs]
    }
  },
  {
    path: "management/leads/health",
    element: <HealthLeadsListing />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  },
  {
    path: "management/leads/health/leads-form/:id?",
    element: <HealthLeadsForm />,
    handle: {
      crumbs: [...parentBreadCrumbs]
    }
  }
];
